import { useSelector } from 'react-redux';
import { useQuery, useMutation, useQueryCache } from 'react-query';
import isBoolean from 'lodash/isBoolean';

import { getLoggedInUserId } from 'selectors/loggedInUser';
import { get, patch } from '@xmatters/redux/services/httpService';
import { useLocalStorage } from 'hooks/useLocalStorage';

const peopleBaseUri = '/webapi/xm/1/people/';

export const useGetUserQuickStartProgress = () => {
  const loggedInUserId = useSelector(getLoggedInUserId);

  return useQuery(
    ['quickStartProgress', loggedInUserId],
    () =>
      get({
        uri: `${peopleBaseUri}${loggedInUserId}/user-guides`,
      }),
    {
      enabled: true,
    },
  );
};

export const useUpdateUserQuickStartProgress = () => {
  const loggedInUserId = useSelector(getLoggedInUserId);
  const queryCache = useQueryCache();

  return useMutation(
    sectionId =>
      patch({
        uri: `${peopleBaseUri}${loggedInUserId}/user-guides`,
        params: {
          onboarding: {
            actionTaken: sectionId,
          },
        },
      }),
    {
      onSuccess: () => {
        queryCache.invalidateQueries(['quickStartProgress']);
      },
      throwOnError: true,
    },
  );
};

export const useQuickStartStatus = () => {
  const { data, isFetching, isStale } = useGetUserQuickStartProgress();

  const isLoading = isFetching || isStale;
  const completed = isLoading ? [] : data.onboarding.completed;

  return { isLoading, completed };
};

export const useShowQuickStartOnLogin = () => {
  const loggedInUserId = useSelector(getLoggedInUserId);
  return useLocalStorage(`xmShowQuickStartOnLogin_${loggedInUserId}`, true, {
    validator: isBoolean,
  });
};
